import * as Yup from "yup";
import { flow } from "./flow";

const {
  formField: { flowName, description, integration },
} = flow;

const validations = Yup.object().shape({
  [flowName.name]: Yup.string().required(flowName.errorMsg).max(50),
  [description.name]: Yup.string().max(500),
  [integration.name]: Yup.array(Yup.string()),
});

export default validations;
